import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
})
export class SelectOptionComponent implements OnInit {

  @Input() value:any = null;
  @Input() unique:boolean = false;
  @Input() hide:boolean = false;
  @ViewChild('text') text:ElementRef;

  constructor() { }

  ngOnInit() {}

}
